import React from 'react';
import propTypes from 'prop-types';
export const SunRiseIcon = ({ size, color, variant }) => {
  const sizeInPixel = `${size}px`;
  return (
    <svg
      width={sizeInPixel}
      height={sizeInPixel}
      className={variant}
      fill={color}
      viewBox="0 0 32 32"
      id="icon"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="2" y="27" width="27.9985" height="2" />
      <path d="M16,20a4.0045,4.0045,0,0,1,4,4h2a6,6,0,0,0-12,0h2A4.0045,4.0045,0,0,1,16,20Z" />
      <rect x="25" y="22" width="5" height="2" />
      <rect
        x="21.6675"
        y="14.8536"
        width="4.958"
        height="1.9998"
        transform="translate(-4.1378 21.7175) rotate(-45)"
      />
      <polygon points="16 4 11 9 12.41 10.41 15 7.83 15 8 15 15 17 15 17 8 17 7.83 19.59 10.41 21 9 16 4" />
      <rect
        x="6.8536"
        y="13.3745"
        width="1.9998"
        height="4.958"
        transform="translate(-8.9099 10.1967) rotate(-45)"
      />
      <rect x="2" y="22" width="5" height="2" />
      <rect
        id="_Transparent_Rectangle_"
        data-name="&lt;Transparent Rectangle&gt;"
        fill="none"
        width={sizeInPixel}
        height={sizeInPixel}
      />
    </svg>
  );
};
SunRiseIcon.prototype = {
  size: propTypes.number,
  color: propTypes.string,
  variant: propTypes.string,
};
SunRiseIcon.defaultProps = {
  size: 18,
  color: 'black',
  varient: '',
};
